export const TEST_ID = 'siteFooter';
